import React, { useCallback, useEffect, useMemo, useState, useContext } from "react";
import { Tooltip, Popover } from "antd";
import IconFont, { IconThirdApp, IconMore } from "@/components/icon";
import Rete from "@/components/ThirdApp/components/Rate";
import {
  FavoriteType,
  TopType,
  RecommendedType,
  RecommendedTypeTitle,
  StatusLabels,
  StatusLabelsStyles,
  StatusLabelsText
} from "@/services/AppStore";
import Bus from "@/utils/bus";
import thirdAppAnalyticsMap from "@/utils/thirdAppAnalyticsMap";
import { appItemMenus, MenuType } from "../ThirdMenu";
import CornerMark from "../CornerMark";
import { changeEgovUrl, isMebjJZB } from "@/utils/tools";
import { analysisLog } from "@/utils/logAnalytics";
import { ThirdAppContext, appTrailApply } from "@/components/ThirdApp/utils";
import { connect } from "dva";
import { ThirdAppState } from "@/models/thirdapp";
import styles from "./AppItem.module.less";

function AppItem({
  appInfo,
  moreHidden,
  thirdAppMsgCount,
  eventHidden,
  tooltipHidden
}: {
  appInfo: any;
  moreHidden?: boolean;
  thirdAppMsgCount: any;
  eventHidden?: boolean;
  tooltipHidden?: boolean;
}) {
  const [showMoreBtn, setShowMoreBtn] = useState(false);
  const [resLables, setResLables] = useState<any>([]);
  const { notifyer } = useContext(ThirdAppContext);
  // 介绍&来源
  const ToolText = (desc: string, source: string, csTelephone: string) => {
    return (
      <div>
        {desc && <p>简介：{desc}</p>}
        {source && <p>开发者：{source}</p>}
        {csTelephone && <p>联系电话：{csTelephone ? csTelephone.split("\n").join("、") : ""}</p>}
      </div>
    );
  };
  // 添加常用
  const AddFavorite = ({ favoriteType }: { favoriteType: number }) => {
    const [isShowTools, setIsShowTools] = useState<boolean>(false);
    return (
      <span
        className="third-popover"
        onClick={(e) => {
          setIsShowTools(!isShowTools);
          e.stopPropagation();
        }}
      >
        {IconMore}
        {isShowTools ? (
          <div className="third-popover-menu">
            <span
              className="third-favorite-text"
              style={{
                color: "#323233"
              }}
              onClick={(e) => {
                e.stopPropagation();
                setIsShowTools(false);
                analysisLog(
                  "xtbg_workbench_1",
                  "5",
                  appInfo.applicationId,
                  appInfo.name,
                  appInfo?.applicationKey || ""
                );
                appItemMenus({ appInfo, menuType: MenuType.AboutModal });
                // if (favoriteType === FavoriteType.FavoriteNo) {
                //     Bus.emit('onAddFavoriteThirdApp', appInfo);
                // } else {
                //     Bus.emit('removeFavoriteThirdApp', appInfo);
                // }
              }}
            >
              关于应用
            </span>
            {/* {appInfo.recommended === RecommendedType.RecommendedNo && ( */}
            {appInfo.topType === TopType.TopNo && (
              <span
                className="third-favorite-text"
                style={{
                  color: favoriteType === FavoriteType.FavoriteNo ? "#323233" : "#323233"
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsShowTools(false);
                  appItemMenus({
                    appInfo,
                    favoriteType,
                    menuType: MenuType.AddThirdApp
                  });
                }}
              >
                {favoriteType === FavoriteType.FavoriteNo ? "添加常用" : "取消常用"}
              </span>
            )}
            {/* )} */}
          </div>
        ) : (
          <div />
        )}
      </span>
    );
  };
  const getCornerMarkOptions = useCallback(() => {
    const arr = [];
    if (appInfo.isOnlyMobile) {
      arr.push({
        text: StatusLabelsText[StatusLabels.ONLY_MOBILE],
        styles: StatusLabelsStyles[StatusLabels.ONLY_MOBILE]
      });
    }
    if ((appInfo.applicationStatusLabels || []).includes(StatusLabels.UNDER_MAINTENANCE)) {
      arr.push({
        text: StatusLabelsText[StatusLabels.UNDER_MAINTENANCE],
        styles: StatusLabelsStyles[StatusLabels.UNDER_MAINTENANCE]
      });
    }
    if (appInfo.recommended === RecommendedType.RecommendedYes) {
      arr.push({
        text: RecommendedTypeTitle[RecommendedType.RecommendedYes],
        styles: StatusLabelsStyles.default
      });
    }
    if ((appInfo.applicationStatusLabels || []).includes(StatusLabels.BETA)) {
      arr.push({
        text: StatusLabelsText[StatusLabels.BETA],
        styles: StatusLabelsStyles[StatusLabels.BETA]
      });
    }
    return arr;
  }, [appInfo.applicationStatusLabels, appInfo.isOnlyMobile, appInfo.recommended]);
  const cornerMarkOptions: any = getCornerMarkOptions();
  // const resLables: any[] = [];
  useEffect(() => {
    const cornerMarkOptions: any = getCornerMarkOptions();
    const lables = []
      .concat(appInfo.networkEnvLabels || [])
      .concat(appInfo.applicationStatusLabels || []);
    const theLables: any[] = [];
    let wordNum = 0;

    (appInfo.tags || []).forEach((item: any) => {
      wordNum += item.name.length;
      if (wordNum <= 10) {
        theLables.push(item);
      } else {
        setShowMoreBtn(true);
      }
      return "";
    });
    lables.forEach((key: any, index: any) => {
      const text = StatusLabelsText[key];
      if (
        !(
          cornerMarkOptions.find((item: any) => item.text === text) ||
          text === StatusLabelsText[StatusLabels.VPN]
        )
      ) {
        wordNum += text.length;
        if (wordNum <= 10) {
          theLables.push({ tagId: index, teamId: null, name: text, type: null });
        } else {
          setShowMoreBtn(true);
        }
      }
    });
    setResLables(theLables);
  }, [appInfo, getCornerMarkOptions]);
  // const resLables = theLables.concat(appInfoLables);
  const tipComp = useMemo(() => {
    const hasTip = thirdAppMsgCount[appInfo?.applicationId]?.badge;
    if (hasTip && typeof hasTip === "number") {
      return (
        <div className={styles["appDot"]}>
          <span>
            {hasTip > 99
              ? `${isMebjJZB() ? <IconFont type="iconapp_btn_joymerting_more" /> : "99+"}`
              : hasTip}
          </span>
        </div>
      );
    } else {
      return null;
    }
  }, [appInfo?.applicationId, thirdAppMsgCount]);
  return (
    <Tooltip
      title={
        tooltipHidden
          ? ""
          : ToolText(appInfo.brief || appInfo.name, appInfo.developer, appInfo.csTelephone)
      }
      key={appInfo.applicationId}
      placement="bottom"
      getPopupContainer={(trigger) => {
        return trigger.parentNode as HTMLElement;
      }}
      overlayStyle={{ color: "#494949", width: "248px" }}
    >
      <span
        className={
          appInfo.deploymentEnvironment === 2
            ? "third-content-item third-content-item_lightblue_bg"
            : "third-content-item third-content-item_lightred_bg"
        }
        clstag={thirdAppAnalyticsMap[appInfo.applicationKey]?.click}
        onClick={() => {
          if (eventHidden) {
            return false;
          }
          appTrailApply(
            appInfo.applicationId,
            () => {
              Bus.emit("openThirdApp", appInfo);
            },
            notifyer,
            appInfo
          );
          // Bus.emit("openThirdApp", appInfo);
        }}
        onKeyDown={() => {}}
        tabIndex={0}
        role="button"
      >
        {/* 工具图标 */}
        <div className={`third-content-item_logo ${appInfo.isVisibility ? "" : ""}`}>
          {appInfo.icon ? (
            <img src={changeEgovUrl(appInfo.icon)} alt="" />
          ) : (
            <span style={{ fontSize: 22 }}>{IconThirdApp}</span>
          )}
          {tipComp}
        </div>
        {/* 工具名称及简述 */}
        <div className="third-content-item_info">
          <span className="third-content-item_text">{appInfo.name}</span>
          {appInfo.builder ? (
            <span className="third-content-item_developer">{appInfo.builder}</span>
          ) : (
            <span style={{ height: "15px" }} />
          )}
          {/* <span className="third-content-item_brief">{appInfo.brief}</span>
          <span
            className="third-content-item_developer"
            style={{
              borderBottom: "1px solid #E8EBEC",
              paddingBottom: "6px",
              marginBottom: "6px",
              marginTop: "7px"
            }}
          >
            开发者：{appInfo.developer}
          </span> */}
          <span className="third-content-item_lable">
            {/* {lables.map((key: any, index: any) => {
              const text = StatusLabelsText[key];
              if (
                cornerMarkOptions.find((item: any) => item.text === text) ||
                text === StatusLabelsText[StatusLabels.VPN]
              ) {
                return "";
              }
              return <span key={"net" + index}>{text}</span>;
            })} */}
            {(resLables || []).map((item: any) => {
              return <span key={item.tagId}>{item.name}</span>;
            })}
            {showMoreBtn ? "..." : ""}
          </span>
        </div>
        {/* 推荐 */}
        {!!cornerMarkOptions.length && (
          <div className="thirdapp-item-recommended">
            <CornerMark text={cornerMarkOptions[0].text} styles={cornerMarkOptions[0].styles} />
          </div>
        )}
        {/* 添加常用 */}
        {/* {appInfo.recommended === RecommendedType.RecommendedNo && ( */}
        <div className="thirdapp-item-favorite">
          {moreHidden ? <span /> : <AddFavorite favoriteType={appInfo.favorite} />}
        </div>
        {/* )} */}
      </span>
    </Tooltip>
  );
}

function mapStateToProps({ thirdapp }: { thirdapp: ThirdAppState }) {
  const { thirdAppMsgCount } = thirdapp;
  return {
    thirdAppMsgCount
  };
}
function mapDispatchToProps(dispatch: any) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(AppItem);
